const fractionalEngagementLevel = {
    advisory: {
        name: "Advisory",
        definition: "A strategic, senior-level Learning & Development partnership providing as-needed guidance, planning, and decision support without responsibility for day-to-day execution."
    },

    operational: {
        name: "Operational",
        definition: "A hands-on, flexible Learning & Development partnership delivering continuous support across multiple learning initiatives as priorities evolve.",
    },

    embedded: {
        name: "Embedded",
        definition: "A deeply integrated Learning & Development partnership in which a dedicated professional operates as an extension of the Client’s internal team to support ongoing, enterprise-level learning initiatives."
    }
}

export default fractionalEngagementLevel;